import React from "react";
import { labels } from "../../../../../localization/labels";
import SearchTree from "../../../../core/SearchTree";

const ClassificationSelectionInput = ({
  data,
  loadedKeys,
  loadData,
  pageInfo,
  onPageNumberClick,
  onSearchChange,
  treeRef,
  searchValue,
  checkedKeys,
  onCheck
}) => {
  return (
    <SearchTree
      className="tree-modal"
      title={labels.chooseClassification}
      data={data}
      treeRef={treeRef}
      loadData={loadData}
      pageInfo={pageInfo}
      onPageNumberClick={onPageNumberClick}
      searchable
      onSearchChange={onSearchChange}
      searchValue={searchValue}
      loadedKeys={loadedKeys}
      checkable
      checkedKeys={checkedKeys}
      onCheck={onCheck}
    />
  );
};

export default ClassificationSelectionInput;
